import {TrackingErrorsFactory} from '../Errors/factory.js'
import AdvertisementsValueObject from './AdvertisementsValueObject.js'
import {LeadHitTrackingValueObject} from './LeadHitTrackingValueObject.js'
import {PageViewHitTrackingValueObject} from './PageViewHitTrackingValueObject.js'
import TrackingDataValueObject from './TrackingDataValueObject.js'

export default class TrackingValueObjectsFactory {
  /* eslint-disable camelcase */
  static advertisementsValueObject = ({products, filteredProvinces}) =>
    new AdvertisementsValueObject({products, filteredProvinces})
  /* eslint-enable camelcase */

  static pageViewHitTrackingValueObject = ({adId}) => {
    PageViewHitTrackingValueObject.validate({
      adId,
      errorFactory: TrackingErrorsFactory.savePageViewHitTrackingError
    })
    return new PageViewHitTrackingValueObject({adId})
  }

  static trackingDataValueObject = ({event, data, identify, reset}) =>
    new TrackingDataValueObject({event, data, identify, reset})

  static leadHitTrackingValueObject = ({hitId}) => new LeadHitTrackingValueObject({hitId})
}
